
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1t44z_pnydo_141",
  "hover-area": "awsui_hover-area_1t44z_pnydo_177",
  "popover-body": "awsui_popover-body_1t44z_pnydo_185"
};
  